export default __webpack_public_path__ + "6a2bc8189d7ea5116270c0a4c2769a87.png";